import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import '../../styles/pages/libraryClosureNotice.scss';

// The announcement is active for both days in Turkey, regardless of browser timezone.
const NOTICE_START = Date.parse('2026-10-28T00:00:00+03:00');
const NOTICE_END = Date.parse('2026-10-30T00:00:00+03:00');

const LibraryClosureNotice = ({ currentTime }) => {
  const [dismissed, setDismissed] = useState(false);
  const isVisible = !dismissed && currentTime >= NOTICE_START && currentTime < NOTICE_END;
  const handleClose = () => setDismissed(true);

  return (
    <Dialog
      open={isVisible}
      onClose={handleClose}
      aria-labelledby="library-closure-title"
      aria-describedby="library-closure-description"
      className="library-closure-notice"
      maxWidth={false}
      fullWidth
    >
      <DialogTitle id="library-closure-title">
        Kütüphanelerimiz Kapalı Olacaktır
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="library-closure-description" component="div">
          <p>
            Kütüphanemiz, gerçekleştirilecek bakım çalışmaları ve 29 Ekim Cumhuriyet Bayramı resmî tatili dolayısıyla 28-29 Ekim tarihlerinde hizmete kapalı olacaktır.
          </p>
          <p className="library-closure-notice__reopening">
            30 Ekim Cuma günü itibarıyla hizmet vermeye devam edeceğiz.
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" disableElevation>
          Tamam
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LibraryClosureNotice;
